
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCallUsage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.252 5.129a6.543 6.543 0 0 1 4.62 4.62M13.575 7.653a3.926 3.926 0 0 1 2.772 2.772",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.464 12.059a7.576 7.576 0 0 0 3.508 3.492.712.712 0 0 0 .704-.053l2.248-1.5a.719.719 0 0 1 .682-.063l4.208 1.804c.293.124.47.428.43.745a4.313 4.313 0 0 1-4.277 3.766C9.22 20.25 3.75 14.78 3.75 8.033a4.313 4.313 0 0 1 3.766-4.278.716.716 0 0 1 .745.431l1.805 4.211a.718.718 0 0 1-.06.677l-1.494 2.284a.712.712 0 0 0-.048.7Z",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M14.252 5.12891C16.5053 5.73492 18.2654 7.49502 18.8714 9.74835\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M13.5752 7.65332C14.9272 8.01693 15.9833 9.07299 16.3469 10.425\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.46403 12.0587C9.20948 13.5828 10.4448 14.8125 11.9723 15.551C12.1996 15.6588 12.467 15.6385 12.6755 15.4978L14.9245 13.9981C15.1266 13.8634 15.3831 13.8398 15.6063 13.9355L19.8137 15.7387C20.1074 15.8634 20.2831 16.1673 20.2448 16.484C19.9697 18.6369 18.1375 20.2499 15.9671 20.25C9.21978 20.25 3.75 14.7802 3.75 8.03291C3.75011 5.86251 5.36313 4.03035 7.51601 3.75522C7.83271 3.71689 8.13658 3.89263 8.26131 4.18625L10.0661 8.39736C10.1609 8.61859 10.1387 8.8726 10.0068 9.074L8.51237 11.3575C8.37401 11.5665 8.35565 11.8328 8.46403 12.0587Z\" stroke=\"black\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/callUsage.9a1a480802400b7385b66009cf9df543.svg"),
        {
          React: SvgCallUsage,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      